import { useQuery } from '@tanstack/react-query';
import { compensationService } from '@/services/compensation/compensationService';
import { compensationKeys } from './queryKeys';

/**
 * Hook to get the hourly rate for a profile from their assigned compensation rules
 */
export const useHourlyRateRule = (profileId: string | null) => {
  return useQuery({
    queryKey: [...compensationKeys.all, 'hourly-rate', profileId],
    queryFn: async () => {
      if (!profileId) return null;
      
      const rules = await compensationService.getAssignedRules(profileId, {
        ruleType: 'hourly_rate',
        activeOnly: true
      });
      
      // Return the highest priority (first) active hourly rate rule
      const hourlyRule = rules.find(rule => rule.rule_type === 'hourly_rate');
      return hourlyRule ? Number(hourlyRule.base_rate) : 0;
    },
    enabled: !!profileId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};